import React from "react";
import { Link } from "react-router-dom";

function Header() {
  return (
    <div className=" w-[100%] h-[5rem] flex flex-col mb-[2.5rem] sm:mb-0 sm:flex-row items-center">
      <div className=" w-[100%] sm:w-[33.33%] flex my-[0.7rem] sm:my-0 sm:items-center justify-center">
        <Link to="/">
          <svg
            className=" cursor-pointer w-[2rem] fill-[#fe395d]"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 448 512"
          >
            <path d="M224 373.12c-25.24-31.67-40.08-59.43-45-83.18-22.55-88 112.61-88 90.06 0-5.45 24.25-20.29 52-45 83.18zm138.15 73.23c-42.06 18.31-83.67-10.88-119.3-50.47 103.9-130.07 46.11-200-18.85-200-54.92 0-85.16 46.51-73.28 100.5 6.93 29.19 25.23 62.39 54.43 99.5-32.53 36.05-60.55 52.69-85.15 54.92-50 7.43-89.11-41.06-71.3-91.09 15.1-39.16 111.72-231.18 115.87-241.56 15.75-30.07 25.56-57.4 59.38-57.4 32.34 0 43.4 25.94 60.37 59.87 36 70.62 89.35 177.48 114.84 239.09 13.17 33.07-1.37 71.29-37.01 86.64zm47-136.12C280.27 35.93 273.13 32 224 32c-45.52 0-64.87 31.67-84.66 72.79C33.18 317.1 22.89 347.19 22 349.81-3.22 419.14 48.74 480 111.63 480c21.71 0 60.61-6.06 112.37-62.4 58.68 63.78 101.26 62.4 112.37 62.4 62.89.05 114.85-60.86 89.61-130.19.02-3.89-16.82-38.9-16.82-39.58z" />
          </svg>
        </Link>
        <Link to="/">
          <span className=" cursor-pointer ml-[0.3rem] text-[#fe395d] text-[1.4rem] font-bold">
            airbnb
          </span>
        </Link>
      </div>

      <div className=" w-[100%] sm:w-[33.33%] sm:flex sm:items-center justify-center">
        <div className=" cursor-pointer flex items-center justify-center rounded-full border-[0.2px] border-slate-400 py-[0.25rem] text-[0.9rem] shadow-sm hover:shadow-slate-400">
          <span className=" ml-[1.3rem] font-semibold text-[0.75rem] sm:text-[0.9rem]">
            Anywhere
          </span>
          <span className=" ml-[0.8rem] text-slate-300">|</span>
          <span className=" ml-[0.8rem] font-semibold text-[0.75rem] sm:text-[0.9rem]">
            Any week
          </span>
          <span className=" ml-[0.8rem] text-slate-300">|</span>
          <span className=" ml-[0.8rem] font-extralight text-[0.75rem] sm:text-[0.9rem]">
            Add guests
          </span>
          <div className=" ml-[0.8rem] mr-[0.5rem] border-[0.5rem] border-[#fe395d] rounded-full">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={3}
              stroke="white"
              className="w-[1rem] bg-[#fe395d]"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M21 21l-5.197-5.197m0 0A7.5 7.5 0 105.196 5.196a7.5 7.5 0 0010.607 10.607z"
              />
            </svg>
          </div>
        </div>
      </div>

      <div className=" hidden sm:w-[33.33%] sm:flex sm:items-center sm:justify-end">
        <span className=" text-[0.9rem] font-semibold cursor-pointer px-3 py-2 hover:bg-[#f4f1f1] rounded-full">
          Become a host
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className=" mx-[0.4rem] w-[2.6rem] rounded-full cursor-pointer p-[10px] hover:bg-[#f4f1f1]"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 21a9.004 9.004 0 008.716-6.747M12 21a9.004 9.004 0 01-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 017.843 4.582M12 3a8.997 8.997 0 00-7.843 4.582m15.686 0A11.953 11.953 0 0112 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0121 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0112 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 013 12c0-1.605.42-3.113 1.157-4.418"
          />
        </svg>
        <div className=" hover:shadow-md cursor-pointer flex gap-[0.3rem] py-[0.2rem] border-[2px] rounded-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="w-[1.2rem] ml-[0.55rem]"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
            />
          </svg>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="#fe395d"
            className="w-[2rem] ml-[0.3rem] mr-[0.25rem] rounded-full"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M17.982 18.725A7.488 7.488 0 0012 15.75a7.488 7.488 0 00-5.982 2.975m11.963 0a9 9 0 10-11.963 0m11.963 0A8.966 8.966 0 0112 21a8.966 8.966 0 01-5.982-2.275M15 9.75a3 3 0 11-6 0 3 3 0 016 0z"
            />
          </svg>
        </div>
      </div>
    </div>
  );
}

export default Header;
